import Spinner from "./Spinner"

import styles from "./BoxSpinner.module.scss"

export const BoxSpinner = () => (
  <div className={styles.box}>
    <Spinner />
  </div>
)
